import { Injectable } from '@angular/core';

import {
  UnicoCheckBuilder,
  SelfieCameraTypes,
  UnicoThemeBuilder,
  CallbackCamera,
  SuccessPictureResponse,
  ErrorPictureResponse,
  SupportPictureResponse,
  MainView,
  SelfieCameraType,
  CameraOpener
} from 'unico-webframe'

import {Observable, Subject} from 'rxjs';

@Injectable()
export class UnicoSelfieCameraService {

  private _takePictureSuccess$: Subject<SuccessPictureResponse> = new Subject();
  private _takePictureError$: Subject<ErrorPictureResponse> = new Subject();
  private _takePictureSupport$: Subject<SupportPictureResponse> = new Subject();

  takePictureSuccess$: Observable<SuccessPictureResponse> = this._takePictureSuccess$.asObservable();
  takePictureError$: Observable<ErrorPictureResponse> = this._takePictureError$.asObservable();
  takePictureSupport$: Observable<SupportPictureResponse> = this._takePictureSupport$.asObservable();

  private unicoCheckBuilder = new UnicoCheckBuilder();
  private unicoCamera?: MainView;
  private cameraOpener?: CameraOpener;

  constructor() {}

  private configureCamera() {

    this.unicoCheckBuilder.setResourceDirectory('/assets/unico/resources');
    this.unicoCheckBuilder.setModelsPath('/assets/unico/models/');

    const unicoTheme = new UnicoThemeBuilder()
      .setColorSilhouetteSuccess('#004077')
      .setColorSilhouetteError('#D50000')
      .setColorSilhouetteNeutral('#fcfcfc')
      .setBackgroundColor('#dff1f5')
      .setColorText('#004077')
      .setBackgroundColorComponents('#004077')
      .setColorTextComponents('#dff1f5')
      .setBackgroundColorButtons('#004077')
      .setColorTextButtons('#dff1f5')
      .setBackgroundColorBoxMessage('#fff')
      .setColorTextBoxMessage('#004077')
      .setHtmlPopupLoading(`<div style='position: absolute; top: 45%; right: 50%; transform:
            translate(50%, -50%); z-index: 10; text-align: center;'>Carregando...</div>`)
      .build();

    this.unicoCheckBuilder.setTheme(unicoTheme);

    this.unicoCamera = this.unicoCheckBuilder.build();
  }

  async startSelfieCamera(selfieCameraType: SelfieCameraType = SelfieCameraTypes.NORMAL) {


    this.configureCamera();

    const callback: CallbackCamera = {

      on: {
        success: (obj: SuccessPictureResponse) => {


          this._takePictureSuccess$.next(obj);


        },
        error: (err: ErrorPictureResponse) => {

          this._takePictureError$.next(err);

        },
        support: (sup: SupportPictureResponse) => {

          this._takePictureSupport$.next(sup);

        }
      }

    };

    this.cameraOpener = await this.unicoCamera?.prepareSelfieCamera('/resources/unico.json', selfieCameraType);

    this.cameraOpener?.open(callback)
  }

  stopCamera() {

    this.unicoCheckBuilder = new UnicoCheckBuilder();
    this.unicoCamera = undefined;
    this.cameraOpener = undefined;

  }
}
